import { render, staticRenderFns } from "./workExperience.vue?vue&type=template&id=30bd11ba&scoped=true"
import script from "./workExperience.vue?vue&type=script&lang=js"
export * from "./workExperience.vue?vue&type=script&lang=js"
import style0 from "./workExperience.vue?vue&type=style&index=0&id=30bd11ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd11ba",
  null
  
)

export default component.exports